import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";

const Plans = () => {
  return (
    <div className="plans__container" id="plans">
    <div className="blur plans__blur-1"></div>
    <div className="blur plans__blur-2"></div>
      <div className="Programs__header">
        <span className="stroke__text">Ready to start</span>
        <span>Your Journey</span>
        <span className="stroke__text">Now withus</span>
      </div>
      <div className="plans">
        {plansData.map((plan, i) => {
          return (
            <div className="plan" key={i}>
              {plan.icon}
              <span>{plan.name}</span>
              <span>$ {plan.price}</span>

              <div className="features">
                {plan.features.map((feature, i) => {
                  return (
                    <div className="feature" key={i}>
                      <img src={whiteTick} alt="" />
                      <span key={i}>{feature}</span>
                    </div>
                  );
                })}
              </div>
              <div>
                <span>See more Benifits </span>
              </div>
              <button className="btn">join Now</button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Plans;
